import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export const StoreCardSkeleton: FC = () => (
  <Card sx={{ borderRadius: 2 }}>
    <Skeleton variant="rectangular" height={160} width="100%" />
    <CardContent sx={{ p: 5, '&:last-child': { pb: 5 } }}>
      <SkeletonText variant="small" width="20%" />
      <SkeletonText variant="h6" width="100%" />
      <Stack direction="row" alignItems="center" spacing={2} sx={{ pt: 1 }}>
        <Skeleton variant="circular" sx={{ width: 24, height: 24 }} />
        <SkeletonText variant="small" width="20%" />
      </Stack>
    </CardContent>
  </Card>
)
